export const ROOT_KEY = 'S';
export const HELP_NAMESPACE = '__HELP__';
